// ts-gql-integrity:ea1b8eadb1226c2d559703120a3dc386
/*
ts-gql-meta-begin
{
  "hash": "3b21561805d03c7315763175c30759e0"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type GetJobSignOffs_FragmentFragment = { cloudId: string, name: string, clientId: string, signOffRequestedByUserId: string | null, signOffRequestedDateUtc: any | null, signOffActionedDateUtc: any | null, signOffStatus: SchemaTypes.JobSignOffStatus };



export type type = TypedDocumentNode<{
  type: "fragment";
  result: GetJobSignOffs_FragmentFragment;
  name: "GetJobSignOffs_Fragment";
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    GetJobSignOffs_Fragment: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"GetJobSignOffs_Fragment\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Job\"}},\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"cloudId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"clientId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"signOffRequestedByUserId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"signOffRequestedDateUtc\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"signOffActionedDateUtc\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"signOffStatus\"},\"arguments\":[],\"directives\":[]}]}}]}")
